import {useEffect,useState} from 'react';
import { useNavigate ,useParams} from "react-router-dom";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

import Alert from '@mui/material/Alert';

import MenuBookIcon from '@mui/icons-material/MenuBook';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

//import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
//import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

//import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
//import FormHelperText from '@mui/material/FormHelperText';
//import { deepOrange, green } from '@mui/material/colors';
import Skeleton from '@mui/material/Skeleton';

//import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
//import Button from '@mui/material/Button';

//import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
//import Button from '@mui/material/Button';
//import Typography from '@mui/material/Typography';
//import Icon from '@mui/material/Icon';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { convertToRaw,convertFromRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { Fragment } from "react";

import parse from 'html-react-parser';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//import Button from '@mui/material/Button';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
//import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
//import Typography from '@mui/material/Typography';
//import FastfoodIcon from '@mui/icons-material/Fastfood';
//import DeleteIcon from '@mui/icons-material/Delete';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import Grid from '@mui/material/Grid';

import Snackbar from '@mui/material/Snackbar';
//import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
//import Button from '@mui/material/Button';
//import Dialog from '@mui/material/Dialog';
//import DialogActions from '@mui/material/DialogActions';
//import DialogContent from '@mui/material/DialogContent';
//import DialogContentText from '@mui/material/DialogContentText';
//import DialogTitle from '@mui/material/DialogTitle';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'
import SmartPortionComponent from '../components/SmartPortion.jsx'

//services
import AuthService from '../service/auth'
import SettingsService from '../service/Settings'
import ProjectService from '../service/Project'
import ClientService from '../service/Client'
import ClientLogService from '../service/ClientLog'
import ClientMealLogService from '../service/ClientMealLog'
import ClientFoodLogService from '../service/ClientFoodLog'
import FoodService from '../service/Food'
import RecipeService from '../service/Recipe'
import SmartPortionService from '../service/SmartPortion'
import UtilsService from '../service/Utils'


const NotesEditorToolbar ={
  
  //options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
  options: [ 'inline','fontSize','fontFamily','colorPicker'],
  inline:{  options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript']},
  colorPicker:{ },
  /*inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
    bold: { icon: bold, className: undefined },
    italic: { icon: italic, className: undefined },
    underline: { icon: underline, className: undefined },
    strikethrough: { icon: strikethrough, className: undefined },
    monospace: { icon: monospace, className: undefined },
    superscript: { icon: superscript, className: undefined },
    subscript: { icon: subscript, className: undefined },
  },
  blockType: {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  fontSize: {
    icon: fontSize,
    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
 / fontFamily: {
    options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
  list: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered', 'indent', 'outdent'],
    unordered: { icon: unordered, className: undefined },
    ordered: { icon: ordered, className: undefined },
    indent: { icon: indent, className: undefined },
    outdent: { icon: outdent, className: undefined },
  },
  textAlign: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['left', 'center', 'right', 'justify'],
    left: { icon: left, className: undefined },
    center: { icon: center, className: undefined },
    right: { icon: right, className: undefined },
    justify: { icon: justify, className: undefined },
  },
  colorPicker: {
    icon: color,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
      'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
      'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
      'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
      'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
      'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
  },
  link: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    dropdownClassName: undefined,
    showOpenOptionOnHover: true,
    defaultTargetOption: '_self',
    options: ['link', 'unlink'],
    link: { icon: link, className: undefined },
    unlink: { icon: unlink, className: undefined },
    linkCallback: undefined
  },
  emoji: {
    icon: emoji,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    emojis: [
      '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
      '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
      '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
      '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
      '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
      '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
      '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
      '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
      '✅', '❎', '💯',
    ],
  },
  embedded: {
    icon: embedded,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    embedCallback: undefined,
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
  image: {
    icon: image,
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: true,
    uploadCallback: undefined,
    previewImage: false,
    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    alt: { present: false, mandatory: false },
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
  remove: { icon: eraser, className: undefined, component: undefined },
  history: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['undo', 'redo'],
    undo: { icon: undo, className: undefined },
    redo: { icon: redo, className: undefined },
  },*/

}


const formatTime=function(d){
	var d = new Date(d);
	Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
}
    var dformat =[d.getHours().padLeft(),
               d.getMinutes().padLeft()].join(':');
	return dformat;
}

const checkIfNull=function(val){
	return UtilsService.checkIfNull(val);
}

const formatDate=function(d){
	var d = new Date(d);
	Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
}
    var dformat = [
               d.getDate().padLeft(),
			   (d.getMonth()+1).padLeft(),
               d.getFullYear()].join('/') ;
	return dformat;
}

const formatJson=function(s){
	return JSON.stringify(s);
}

const getRandomInt=function(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const removeKeys=function(object,keys){
	var obj={};
	for (let key in object) {
		 if(!keys.includes(key)){
			 obj[key]=object[key];
		 }
	}
	return obj;
}

const returnPages=function(obj,pages,index){
	var keys= Object.keys(obj);
	var n=keys.length;
	var pageSize=0;
	if(n % pages == 0){
		pageSize=n/pages;
	}else{
		pageSize=(n/pages)+1;
	}
	//return pageSize*(index-1);
	return keys.splice(pageSize*(index-1), pageSize);
}

/*modal test*/
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const style_parent = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  overflow:'scroll',
    height:'80%',
    display:'block',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function ChildModal() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
	  console.log('open...');
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button onClick={handleOpen}>Open Child Modal</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 300 ,height:300}}>
          <h2 id="child-modal-title">Text in a child modal</h2>
          <p id="child-modal-description">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit.
          </p>
          <Button onClick={handleClose}>Close Child Modal</Button>
        </Box>
      </Modal>
    </Fragment>
  );
}


//let steps = ['Search food', 'Enter quantity', 'Add food'];
//let steps = ['Search food', 'Enter quantity'];
let skip_step_number=0;
let steps=[];



let quantification_methods =[
'Food atlas',
'Weighed',
'Manufacturer’s information',
'Portions data (HC)',
'Household measure',
'Average portion weights (study specific)',
'Estimated',
];

let cooking_methods=[
'Not cooked',
'Grilled',
'Boiled',
'Steamed/blanched',
'Stewed',
'Fried or stir-fried',
'Deep fat fried',
'Roasted (cooked with fat)',
'Baked (cooked without fat)',
'Microwaved',
'Barbequed',
'Combination of methods',
'Unknown',
'Air-fried/Dry-fried'

];

let beverage_codes=[
'Not applicable',
'Milk in cereal',
'Milk as a beverage',
'Milk in tea/coffee/hot chocolate',
'Milk in soup/sauce',
'Milk added to a composite meal',
'Water as a beverage',
'Water in tea/coffee/hot chocolate',
'Water in soup/sauce',
'Water added to a composite meal',
'Water in effervescent supplement',
'Other'
];

let packaging_types=[
'Glass',
'Glass & Metal',
'Glass & Plastic',
'Glass & Paper & Board',
'Plastic',
'Metallised Plastic',
'Plastic & Metal',
'Plastic & Paper & Board',
'Paper & Board',
'Tetra-pak type packaging',
'Soups/sauces type packet or sachet',
'Canned',
'Foil',
'Metal & Paper & Board',
'Waxes',
'Unknown',
'Loose/unpackaged',
'Packaging Unknown',
'Netting'
];

let meals =['Breakfast','Lunch','Lunch (light meal)','Lunch (main meal)','Evening meal(light meal)','Evening meal (main meal)','Morning snack','Afternoon snack','Evening snack','Night snack','Brunch','Desert','Non alcoholic beverages','Alcoholic beverages','Other'];
let preparedLocations =['Home','Work/College/University','Other persons home','Restaurant/hotel/public house','Coffee shop/sandwich bar/delicatessen','Shop bought','Takeaway/Fast food chain','Cinema','Social function','Meals on wheels/community care','Other'];
let eatenLocations =['Kitchen','Sitting room','Bedroom',' On the go (in house)','On the go (out of the house)','Table in a restaurant or other location (other persons home)','Desk in work','In the car','Other'];
let forgottenFoods=[];				

const ClientLog = () => {
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [globalSettings,setGlobalSettings]=useState({});//global config
	const [globalSettingsLoaded,setGlobalSettingsLoaded]=useState(false);//global config
	const [modulesEnabled,setModulesEnabled]=useState({'questionnaires':false,'recipes':false,'smart_portions':false});
	const [currentUser,setCurrentUser]=useState({});
	const [devMode,setDevMode]=useState({});
	
	const [projectData,setProjectData]=useState([]);
	const [projectSettings,setProjectSettings]=useState({});
	const [projectFound,setProjectFound]=useState(false);
	
	const [clientData,setClientData]=useState([]);
	const [clientLoaded,setClientLoaded]=useState(false);
	
	const [clientFoodLogsData, setClientFoodLogsData] = useState({});
	const [clientFoodLogsDataLoaded,setClientFoodLogsDataLoaded]=useState(false); 
	
	const [clientLogData,setClientLogData]=useState([]);
	const [clientMealLogData,setClientMealLogData]=useState([]);
	const [clientFoodLogData,setClientFoodLogData]=useState([]);
	const [clientMealsByIdLogData,setClientMealsByIdLogData]=useState([]);
	const [clientMealFoodLogData,setClientMealFoodLogData]=useState([]);
	
	const [tempMeal, setTempMeal] = useState({});
	
	const [nameEditMode,setNameEditMode]=useState(false);
	const [tempLogName,setTempLogName]=useState("");
	const handNameEditModeOn = (event) => {
		console.log(event);
		setNameEditMode(true);
	};
	
	const handNameEditModeOff = (event) => {
		console.log(event);
		setNameEditMode(false);
		updateClientLogName(tempLogName);
	};
	
	let params = useParams();
	let client_log_id =params.client_log_id;
	//console.log('client_log_id',client_log_id);
	
	let project_id =ProjectService.getCurrentProject();//params.id;
	//console.log('project_id',project_id);
		
	useEffect(() => {
		
		let _loggedInStatus = AuthService.getUserLoggedInStatus();
		if(_loggedInStatus.loggedIn){
			
			setCurrentUser(AuthService.getCurrentUser());
			setDevMode(AuthService.isDevMode());
			SettingsService.getAllFormatted().then(function(res){
				let _globalSettings=res.data;
				setGlobalSettings(res.data);
				setGlobalSettingsLoaded(true);
				console.log(res.data);
				
				var account_type=AuthService.getCurrentUser().__t;
				//console.log('account_type',account_type);
				
				if(typeof _globalSettings.modules!=="undefined"){
					
					//update local modules enabled variables
					setModulesEnabled({
						'questionnaires':_globalSettings.modules.settings.questionnaires.on,
						'recipes':_globalSettings.modules.settings.recipes.on,
						'smart_portions':_globalSettings.modules.settings.smart_portions.on
					});
					
					
				console.log('_globalSettings.modules.settings.recipes',_globalSettings.modules.settings.recipes.on);
				console.log('modulesEnabled',modulesEnabled.recipes);
				if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
								loadFoodDataByFilter({$or:true,'global':true,'active':true,'approved':true,'project':project_id});
								if(_globalSettings.modules.settings.recipes.on){
									loadRecipes({'project':project_id});
								}
								
							}else{
								loadFoodDataByFilter({$or:true,'global':true,'active':true,'approved':true,});
								if(_globalSettings.modules.settings.recipes.on){
									loadRecipes({'global':true});
								}
							}
							loadFoodTranslation()
							
							if((typeof client_log_id !=="undefined")&&(client_log_id!==null)){
								loadClientLogById(client_log_id);
								//loadClientMealLogById(client_log_id);
								//loadClientFoodLogById(client_log_id);
								loadClientMealFoodLogById(client_log_id);
							}
							//load
							if(account_type=='Admin'){//Admin
						
							}else if(account_type=='Master'){//Master
							
								
							}else if(account_type=='Researcher'){//Researcher
								
							}

			
				}
				
							
							

			}).catch(function(error){
				console.log(error);
			});
			
		}else{
			navigate(_loggedInStatus.redirectUrl);
		}
		/*if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				//console.log('account_type',account_type);
				
				//console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						//console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						//console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force change Password
						if(currentUser.force_password_change){
							//not implemented	
						
						}else{
							if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
								loadFoodDataByFilter({$or:true,'global':true,'active':true,'approved':true,'project':project_id});
								//loadRecipes({'project':project_id});
							}else{
								//loadFoodData();
								loadFoodDataByFilter({$or:true,'global':true,'active':true,'approved':true,});
								//loadRecipes({'global':true});
							}
							loadFoodTranslation()
							
							if((typeof client_log_id !=="undefined")&&(client_log_id!==null)){
								loadClientLogById(client_log_id);
								//loadClientMealLogById(client_log_id);
								//loadClientFoodLogById(client_log_id);
								loadClientMealFoodLogById(client_log_id);
							}
							//load
							if(account_type=='Admin'){//Admin
						
							}else if(account_type=='Master'){//Master
							
								
							}else if(account_type=='Researcher'){//Researcher
								
							}
						}
					}
				}	
		}*/
	}, []);
	
	
	function loadProjectById(project_id){
		ProjectService.getById(project_id).then(function(res){
		setProjectData(res.data);
		setProjectSettings(res.data.settings);
		let _settings= res.data.settings;
		console.log('_settings',_settings);

		
		if(typeof _settings['quantification_methods'] !=="undefined"){
			quantification_methods=_settings['quantification_methods'];
		}

		if(typeof _settings['cooking_methods'] !=="undefined"){
			cooking_methods=_settings['cooking_methods'];
		}
		
		if(typeof _settings['beverage_codes'] !=="undefined"){
			beverage_codes=_settings['beverage_codes'];
		}
		
		if(typeof _settings['packaging_types'] !=="undefined"){
			packaging_types=_settings['packaging_types'];
		}
		
		if(typeof _settings['meal_types'] !=="undefined"){
			meals=_settings['meal_types'];
		}
		
		if(typeof _settings['location_types'] !=="undefined"){
			preparedLocations=_settings['location_types'];
		}
		
		if(typeof _settings['eaten_location'] !=="undefined"){
			eatenLocations=_settings['eaten_location'];
		}
		
		if(typeof _settings['forgotten_foods'] !=="undefined"){
			forgottenFoods=_settings['forgotten_foods'];
		}
		
		if(typeof _settings['skip_step_3'] !=="undefined"){
			if(_settings['skip_step_3']=='yes'){
				steps = ['Search food', 'Enter quantity'];
				skip_step_number=1;
			}else{
				steps = ['Search food', 'Enter quantity', 'Add food'];
				skip_step_number=2;
			}
		}
		console.log('_settings[skip_step_3]',_settings['skip_step_3']);
		console.log('steps',steps);
		console.log('skip_step_number',skip_step_number);
		
		
		//quantification_methods=['test'];
		console.log(res.data);
		setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
	function loadClientById(client_id){
			ClientService.getById(client_id).then(function(res){
				setClientData(res.data);
				setClientLoaded(true);
				console.log(res.data);
				var _client= res.data;

				console.log('_client',_client);
			}).catch(function(error){
					console.log(error);
			});
	}


	/* client logs */
		function loadClientMealFoodLogById(client_log_id){
				ClientLogService.getMealFood(client_log_id).then(function(res){
					setClientLogData(res.data.log);
					setClientMealFoodLogData(res.data.meal_foods);
					setClientMealLogData(res.data.meals);
					setClientFoodLogData(res.data.foods);
					setClientMealsByIdLogData(res.data.meals_by_id);
					console.log(res.data);
					//var _client_id=res.data.client;
					//loadClientById(_client_id);
				}).catch(function(error){
						console.log(error);
				});
		}

		
		function loadClientLogById(client_log_id){
				ClientLogService.getById(client_log_id).then(function(res){
					setClientLogData(res.data);
					console.log(res.data);
					var _client_log=res.data;
					var _client_id=res.data.client;
					
					setTempLogName(_client_log.name);
					loadClientById(_client_id);
					
					var clientLogNotes = _client_log.notes;
					if(clientLogNotes==''){
						clientLogNotes={};
					}
					setLogNotesEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(clientLogNotes))));
				
				}).catch(function(error){
						console.log(error);
				});
		}
		
		function updateClientLogName(name){
			clientLogData.name=name
				ClientLogService.update(clientLogData).then(function(res){
					
					console.log(res.data);
					
				}).catch(function(error){
						console.log(error);
				});
		}
		
		function updateClientLogNotes(notes){
			clientLogData.notes=notes
				ClientLogService.update(clientLogData).then(function(res){
					
					console.log(res.data);
					
				}).catch(function(error){
						console.log(error);
				});
		}
		
		function loadClientMealLogById(client_log_id){
				ClientMealLogService.getByFilter({'client_log_id':client_log_id}).then(function(res){
					setClientMealLogData(res.data);
					console.log(res.data);
					var _mealsLogged=res.data;
					console.log('_mealsLogged',_mealsLogged);
					console.log('_mealsLogged length',_mealsLogged.length);
					/*var _m ={}
					for(var i=0;i<_mealsLogged.length;i++){
						var _meal= _mealsLogged[i];
						_m[_meal._id]=[];
					}
					console.log('_m',_m);
					setClientFoodLogsData(_m);*/
					loadClientFoodLogById(client_log_id);
					
				}).catch(function(error){
						console.log(error);
				});
		}
		

		function loadClientFoodLogById(client_log_id){
				ClientFoodLogService.getByFilter({'client_log_id':client_log_id}).then(function(res){
					//setClientFoodLogData(res.data);
					console.log(res.data);
					var loggedFoods=res.data;
					console.log(loggedFoods);
					console.log('clientMealLogData.length.length',clientMealLogData.length);
					console.log('loggedFoods.length',loggedFoods.length);
					
					var _m ={}
					for(var i=0;i<clientMealLogData.length;i++){
						var _meal= clientMealLogData[i];
						_m[_meal._id]=[];
					}
					console.log('_m',_m);
					
					for(var i=0;i<loggedFoods.length;i++){
						var _foodlog=loggedFoods[i];
						console.log('_foodlog',_foodlog);
						console.log('client_meal_log_id',_foodlog.client_meal_log_id);
						if(!_m.hasOwnProperty(_foodlog.client_meal_log_id)){
							//_m[_foodlog.client_meal_log_id]=[];
						}
						_m[_foodlog.client_meal_log_id].push(_foodlog);
						
					}
					console.log('_m',_m);
					setClientFoodLogsData(_m);
					/*
					
					var _f ={};
					
					console.log('Meal length',clientMealLogData.length);
					console.log('clientFoodLogsData',clientFoodLogsData);
					console.log('_f',_f);
					for(var i=0;i<loggedFoods.length;i++){
						var _foodlog=loggedFoods[i];
						console.log('_foodlog',_foodlog);
						console.log('client_meal_log_id',_foodlog.client_meal_log_id);
						//_f[_foodlog.client_meal_log_id].push(_foodlog);
						//if(!_f.hasOwnProperty(_foodlog.client_meal_log_id)){
						//	_f[_foodlog.client_meal_log_id]={"total":0,"foods":[]};
						//}
						//_f[_foodlog.client_meal_log_id]["foods"].push(_foodlog);
						//_f[_foodlog.client_meal_log_id]["total"]++;
					}
					console.log(_f);
					setClientFoodLogsData(_f);*/
				
				setClientFoodLogsDataLoaded(true);
				
				}).catch(function(error){
						console.log(error);
				});
		}
		
		function createClientMealLog(client_log_id,clientMealLog){
			ClientMealLogService.create(clientMealLog).then(function(res){
				console.log(res.data);
				//loadClientMealLogById(client_log_id);
				loadClientMealFoodLogById(client_log_id);
				setNewMealLogModalOpen(false);
			}).catch(function(error){
					console.log(error);
			});
		}
		
		/* Error success message on modal*/
		const [ShowErrorMessage,setErrorStatus]=useState(false); 
		const [ErrorText,setErrorMessage]=useState(""); 
	
		const [ShowSuccessMessage,setSuccessStatus]=useState(false); 
		const [SuccessText,setSuccessMessage]=useState("");
	
		//add new /edit existing meal 
		const [openNewEditMealLogModal, setNewEditMealLogModalOpen] = useState(false);
		const [mealEditMode, setMealEditMode] = useState(false);
		
		const handleNewMealModal= (event) => {
			setMealEditMode(false);
			resetMeal();
			setTempMeal(getMealTemplate());
			setNewEditMealLogModalOpen(true);
		};
		
		const handleEditMealModal= (event,meal) => {
			console.log('meal',meal);
			
			resetMeal();
			setMealEditMode(true);
			setTempMeal(meal);
			
			setMealType(meal.type);
			setMealTypeOther(meal.type_other);
			if(meal.type=="Other"){
				setShowOtherMealType(true);
			}else{
				setShowOtherMealType(false);
			}
			setMealTime(dayjs(meal.time));
			
			setLocationPrepared(meal.location_prepared);
			setLocationPreparedOther(meal.location_prepared_other);
			if(meal.location_prepared=="Other"){
				setShowOtherLocationPrepared(true);
			}else{
				setShowOtherLocationPrepared(false);
			}
			
			setLocationEaten(meal.location_eaten);
			setLocationEatenOther(meal.location_eaten_other);
			if(meal.location_eaten=="Other"){
				setShowOtherLocationEaten(true);
			}else{
				setShowOtherLocationEaten(false);
			}
			
			setTvAndScreenUse(meal.tv_and_screens_use);
			
			setNewEditMealLogModalOpen(true);
		};
		
		const handleNewEditMealLogModalClose =(event) => {
			setTempMeal(getMealTemplate());
			setMealType("");
			setNewEditMealLogModalOpen(false);
		};
		
		function resetMeal (){
			setMealType("");
			setMealTypeOther("");
			setShowOtherMealType(false);
			
			setMealTime((dayjs(new Date().setHours(0, 0, 0, 0))));
			
			setLocationPrepared("");
			setLocationPreparedOther("");
			setShowOtherLocationPrepared(false);
			
			setLocationEaten("");
			setLocationEatenOther("");
			setShowOtherLocationEaten(false);
			
			setTvAndScreenUse(null);
			
		}
		function getMealTemplate(){
			return {
				'type':'',
				'type_other':'',
				'location_prepared':'',
				'location_prepared_other':'',
				'location_eaten':'',
				'location_eaten_other':'',
				'time':'',
				'tv_and_screens_use':'',
				'client_log_id':client_log_id,
				'created_by':AuthService.getCurrentUser()._id
			}
		}
		
		const [openNewMealLogModal, setNewMealLogModalOpen] = useState(false);
		const handleNewMealLogModalOpen = () => {
			//reset 
			console.log('create new meal.....');
			//setSuccessStatus(true);
			//setSuccessMessage("test");
			setNewMealLogModalOpen(true);
		};
		
		const handleNewMealLogModalClose = () => {
			setNewMealLogModalOpen(false);
		};
		
		//meal type
		const [mealType, setMealType] = useState('');
		const [mealTypeOther, setMealTypeOther] = useState('');
		const [showOtherMealType, setShowOtherMealType] = useState(false);
		const handleMealTypeChange = (event) => {
			console.log(event.target.value);
			setMealType(event.target.value);
			if(event.target.value=="Other"){
				setShowOtherMealType(true);
			}else{
				setShowOtherMealType(false);
			}
		};
		
		const handleMealTypeOtherChange = (event) => {
			console.log(event.target.value);
			setMealTypeOther(event.target.value);
			
		};
		
		//new meal log
	const handleSubmitNewMealLog=(event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		//var _tempClientMealLog={'client_log_id':client_log_id,'created_by':AuthService.getCurrentUser()._id};
		//form data 
		const data = new FormData(event.currentTarget);
		//meal type
		console.log('mealType',mealType);
		var otherMealType=null;
		if(mealType=='Other'){
			otherMealType=data.get('otherMealType');
		}
		console.log('otherMealType',otherMealType);
		tempMeal.type=mealType;
		tempMeal.type_other=otherMealType;
		
		//location_prepared
		tempMeal.location_prepared=locationPrepared;
		var otherLocationPrepared=null;
		if(locationPrepared=='Other'){
			otherLocationPrepared=data.get('otherLocationPrepared');
		}
		tempMeal.location_prepared_other=otherLocationPrepared;
	
		//location_eaten
		tempMeal.location_eaten=locationEaten;
		var otherLocationEaten=null;
		if(locationEaten=='Other'){
			otherLocationEaten=data.get('otherLocationEaten');
		}
		tempMeal.location_eaten_other=otherLocationEaten;
	
		//tv_and_screens_use
		tempMeal.tv_and_screens_use=tvAndScreenUse;

		//time
		var _hrsmins=data.get('mealTime');
		var _hrminsarr = _hrsmins.split(':');
		var _tempDate= new Date(clientLogData.date);
		_tempDate.setHours(parseInt(_hrminsarr[0]));
		_tempDate.setMinutes(parseInt(_hrminsarr[1]));
		console.log(_tempDate);
		tempMeal.time=_tempDate;
		
		//notes
		/*if(tempData !== null) {
			console.log(JSON.stringify(tempData));
			tempMeal.notes=JSON.stringify(tempData);
		}else{
			tempMeal.notes=JSON.stringify(tempContent);
		}*/
		console.log('tempMeal',tempMeal);
		
		//console.log('clientLogData',clientLogData.date);
		
		if(mealEditMode){
			ClientMealLogService.update(tempMeal).then(function(res){
				console.log(res.data);
				loadClientMealFoodLogById(client_log_id);
				setNewEditMealLogModalOpen(false);
		}).catch(function(error){
					console.log(error);
		});
		}else{
			ClientMealLogService.create(tempMeal).then(function(res){
				console.log(res.data);
				loadClientMealFoodLogById(client_log_id);
				setNewEditMealLogModalOpen(false);
		}).catch(function(error){
					console.log(error);
		});
		}
		
	};
	
	/*remove meal functions*/
	const [deleteMealModal,setDeleteModal]=useState(false);
	//handleDeleteMealModal
	
	const handleDeleteMealModal= (event,meal) => {
		console.log('meal',meal);
		setDeleteModal(true);
		setTempMeal(meal);
	};
	
	const handleDeleteMealYes= (event) => {
		console.log('tempMeal',tempMeal);
		ClientMealLogService.deleteById(tempMeal.id).then(function(res){
				console.log(res.data);
				loadClientMealFoodLogById(client_log_id);
					setDeleteModal(false);
			}).catch(function(error){
					console.log(error);
			});
	
	};
	
	const handleDeleteMealModalClose= (event) => {
		setDeleteModal(false);

	};
	/*end remove meal functions*/
	
	
	//time
	//const [mealTime, setMealTime] = useState(dayjs(new Date()));
	const [mealTime, setMealTime] = useState(dayjs(new Date().setHours(0, 0, 0, 0)));
	//const [mealFormatedTime, setMealFormatedTime] = useState();
	const handleMealTimeChange = (event) => {
		console.log(event);
		//const tempDate = new Date(event.$d);
		//console.log('tempDate',tempDate);
		//console.log('tempDate time',formatTime(tempDate));
		//setMealTime(formatTime(tempDate));
		
	};
	
		//location prepared
		const [locationPrepared, setLocationPrepared] = useState('');
		const [locationPreparedOther, setLocationPreparedOther] = useState('');
		const [showOtherLocationPrepared, setShowOtherLocationPrepared] = useState(false);
		const handleLocationPreparedChange = (event) => {
			console.log(event.target.value);
			setLocationPrepared(event.target.value);
			if(event.target.value=="Other"){
				setShowOtherLocationPrepared(true);
			}else{
				setShowOtherLocationPrepared(false);
			}
		};
		
		const handleLocationPreparedOtherChange = (event) => {
			console.log(event.target.value);
			setLocationPreparedOther(event.target.value);
		};
		
		//location eaten
		const [locationEaten, setLocationEaten] = useState('');
		const [locationEatenOther, setLocationEatenOther] = useState('');
		const [showOtherLocationEaten, setShowOtherLocationEaten] = useState(false);
		const handleLocationEatenChange = (event) => {
			console.log(event.target.value);
			setLocationEaten(event.target.value);
			if(event.target.value=="Other"){
				setShowOtherLocationEaten(true);
			}else{
				setShowOtherLocationEaten(false);
			}
		};
		
		const handleLocationEatenOtherChange = (event) => {
			console.log(event.target.value);
			setLocationEatenOther(event.target.value);
		};
		
		//tv & screens yes no 
		const [tvAndScreenUse, setTvAndScreenUse] = useState(null);
		const handleTvAndScreenUseChange = (event) => {
			console.log(event.target.value);
			setTvAndScreenUse(event.target.value);
		};
		
	//Notes
	const [tempData,setTempData]=useState(null);
	const tempContent ={"blocks":[{"key":"6vocr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};
		
	const [editorState, setEditorState] = useState(EditorState.createWithContent(convertFromRaw(tempContent)));
	  const onEditorStateChange = function (editorState) {
		setEditorState(editorState);
		const content = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
		console.log(content);
		setTempData(convertToRaw(editorState.getCurrentContent()));
	};
	
	//client log Notes
	const [tempLogNotes,setTempLogNotes]=useState(null);
	const tempContent1 ={"blocks":[{"key":"6vocr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}};
		
	const [logNotesEditorState, setLogNotesEditorState] = useState(EditorState.createWithContent(convertFromRaw(tempContent1)));
	  const onLogNotesEditorStateChange = function (logNotesEditorState) {
		setLogNotesEditorState(logNotesEditorState);
		const content = JSON.stringify(convertToRaw(logNotesEditorState.getCurrentContent()));
		console.log(content);
		console.log("##############################################");
		setTempData(convertToRaw(logNotesEditorState.getCurrentContent()));
		updateClientLogNotes(content);

	};
	
	const [FoodData,setFoodData]=useState([]);
	const [FilteredFoodData,setFilteredFoodData]=useState([]);
	const stepSize=10;
	const [foodListPageSize,setFoodListPageSize]=useState(stepSize);
	const [FoodDataLoaded,setFoodDataLoaded]=useState(false);
	
	function loadFoodDataByFilter(filter){
		FoodService.getByFilter(filter).then(function(res){
			
			let _approved_foods=[];
			let allFoods=res.data;
			for(let i=0;i<allFoods.length;i++){
				if(allFoods[i].approved){
					_approved_foods.push(allFoods[i]);
				}
			}
			setFoodData(_approved_foods);
			setFoodDataLoaded(true);
			//console.log(res.data);
			//console.log('FoodDataLoaded',FoodDataLoaded);
		});
	}
	
	const [foodTranslations,setFoodTranslations]=useState({});
	const [foodTranslationsLoaded,setFoodTranslationsLoaded]=useState(false);
	function loadFoodTranslation(){
		FoodService.getTranslations().then(function(res){
			setFoodTranslations(res.data);
			setFoodTranslationsLoaded(true);
			console.log(res.data);
				//createTemplate(res.data);
		}).catch(function(error){
			console.log(error);
		});
	}
	
	const [RecipeData,setRecipeData]=useState([]);
	function loadRecipes(filter){
		RecipeService.getByFilter(filter).then(function(res){
			setRecipeData(res.data);
			console.log(res.data);
				//createTemplate(res.data);
		}).catch(function(error){
			console.log(error);
		});
	}
	
			
	/*const [openNewFoodLogModal, setNewFoodLogModalOpen] = useState(false);
	const [tempMeal, setTempMeal] = useState({});
		const handleNewFoodLogModalOpen = (e,meal) => {
			setTempMeal(meal);
			setQuantity(100);
			console.log('opening food log form modal....',quantity);
			setNewFoodLogModalOpen(true);
			
		};
		
		const handleNewFoodLogModalClose = () => {
			setNewFoodLogModalOpen(false);
		};
		
	//handleAddFoodToLog
	
	const handleAddFoodToLog = (e,food) => {
		console.log('tempMeal',tempMeal);

		console.log(food.name);
		//quantity 
		var quantity =getRandomInt(100,200);
		
		console.log('quantity',quantity);
		//setNewFoodLogModalOpen(false);
		var _clientFoodLog={};
		createClientFoodLog(tempMeal,food,quantity);
	};
		
	const handleAddRandomFood = (e) => {
		console.log('tempMeal',tempMeal);
		//console.log('FoodData',FoodData);
		var index =Math.floor(Math.random()*FoodData.length);
		console.log('FoodData.length',FoodData.length);
		console.log('index',index);
		var food = FoodData[index];
		console.log(food.name);
		//quantity 
		var quantity =getRandomInt(100,200);
		
		console.log('quantity',quantity);
		//setNewFoodLogModalOpen(false);
		var _clientFoodLog={};
		createClientFoodLog(tempMeal,food,quantity);
	};
	
	
		
		function createClientFoodLog(meal,food,quantity){
			ClientFoodLogService.create({'client_log_id':client_log_id,'client_meal_log_id':meal._id,'food':food._id,'quantity':quantity,'created_by':AuthService.getCurrentUser()._id}).then(function(res){
				console.log(res.data);
				loadClientMealFoodLogById(client_log_id);
				setNewFoodLogModalOpen(false);
			}).catch(function(error){
					console.log(error);
			});
		}
		*/
		
	//handleFoodSearchChange
	///const [FilteredFoodData,setFilteredFoodData]=useState([]);
	const handleFoodSearchChange = (event) => {
		setFilteredFoodData([]);
		var filteredList=[];
		//console.log(event.target.value);
		var keyword =event.target.value
		if(keyword.length>0){
			//search food data 
			for(var i=0;i<FoodData.length;i++){
			//if(FoodData[i].name)
				if(FoodData[i].name.toLowerCase().includes(keyword.toLowerCase()) || FoodData[i].code.toLowerCase().includes(keyword.toLowerCase())){
					var _food=FoodData[i];
					_food.type='food';
					filteredList.push(_food);
				}
			}
			console.log('modulesEnabled',modulesEnabled.recipes);
			
			//search recipe data 
			if(modulesEnabled.recipes){
				for(var i=0;i<RecipeData.length;i++){
					if(RecipeData[i].name.toLowerCase().includes(keyword.toLowerCase()) || RecipeData[i].code.toLowerCase().includes(keyword.toLowerCase())){
						var _recipe=RecipeData[i];
						_recipe.type='recipe';
						filteredList.push(_recipe);
					}
				}
			}
			
			//sort by name
			let sortedData = filteredList.sort(function(a,b){
			   // here a , b is whole object, you can access its property
			   //convert both to lowercase
				  let x = a.name.toLowerCase();
				  let y = b.name.toLowerCase();

			   //compare the word which is comes first
				  if(x>y){return 1;} 
				  if(x<y){return -1;}
				  return 0;
				});
			setFilteredFoodData(filteredList);
			//setFilteredFoodData([]);
			
		}
		
	}
	
	const handleFoodSearchChange_ = (event) => {
		
		var keyword =event.target.value
	FoodService.getByKeywords(keyword).then(function(res){
			//setFoodData(res.data);
			//setFoodDataLoaded(true);
			console.log(res.data);
		
		});
	
	}
	
	  const handleShowMore=(event,totalSize)=>{//TODO: use totalSize to determine step size of last 
		  setFoodListPageSize(foodListPageSize+stepSize)
	  }

	const selectPage=function(array,total){
		return array.splice(0,total);
	}
	
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [tempFood, setTempFood] = useState({});
  const [tempLogFood, setTempLogFood] = useState({});
    const [openFoodInfo, setFoodInfoOpen] = useState(false);
  const handleFoodInfoOpen = (e,food) => {
	  console.log('open...');
	  console.log('food...',food);
	  setTempFood(food);
    setFoodInfoOpen(true);
  };
  const handleFoodInfoClose = () => {
    setFoodInfoOpen(false);
  };
  
  
    const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  const isStepOptional = (step) => {
    return false;//step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
   /* let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }*/
console.log('activeStep',activeStep);

//if(activeStep==2){/** previous removing step 3 */
//if(activeStep==1){
if(activeStep==skip_step_number){
	
	var clientFoodLog={
		'client_log_id': client_log_id,
		'client_meal_log_id': tempMeal._id,
		'food': tempFood._id,
		'quantity': quantity,
		'quantification_method': quantificationMethod,
		'cooking_method': cookingMethod,
		'beverage_code': beverageCode,
		'packaging_type': packagingType,
		'packaging_size': packagingSize,
		'created_by':AuthService.getCurrentUser()._id
	}
	//food
	if(tempFood.type=='food'){
		clientFoodLog['food']= tempFood._id;
		clientFoodLog['food_or_recipe']= 'food';
	}
	//recipe
	if(tempFood.type=='recipe'){
		clientFoodLog['recipe']= tempFood._id;
		clientFoodLog['food_or_recipe']= 'recipe';
	}
	
	ClientFoodLogService.create(clientFoodLog).then(function(res){
				console.log(res.data);
				
				
				setOpen(false);
				setActiveStep((prevActiveStep) => 0);
				setFilteredFoodData([]);
				loadClientMealFoodLogById(client_log_id);
				
			}).catch(function(error){
					console.log(error);
			});
	
	//console.log('IM FINISHED.....');
		
}else{
	   setActiveStep((prevActiveStep) => prevActiveStep + 1);
	
}
 
    //setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  

    const handleOpenFoodModal = (e,meal) => {
		resetClientFoodLogData();
		setFoodListPageSize(stepSize);//reset
		console.log('add food modal.....');
		setTempMeal(meal);
		setFilteredFoodData([]);//clear search
		setActiveStep(0);//back to 1st screen
		setQuantity('');
		setOpen(true);
  };
  
  const handleAddToLog=(event,food)=>{
	  
	  setTempFood(food);
	  loadSmartPortion(food);
	  console.log();
	  console.log('move next.....');
	  setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  }
  
  
  
  const [spOpen, setSpOpen] = useState(false);
  
  	const [smartPortion,setSmartPortion]=useState({});	
	const [smartPortionLoaded,setSmartPortionLoaded]=useState(false);	
	function loadSmartPortion(food){
			SmartPortionService.getByFoodCode(food.code).then(function(res){
				setSmartPortion(res.data);
				console.log(res.data);
				setSmartPortionLoaded(true);
			}).catch(function(error){
					console.log(error);
			});
	}
	
	const handleClick = (e,value) => {
		setSpOpen(true);
     setQuantity(parseInt(value));
  };
  
  const handleUpdateFoodQuantityClick = (e,value) => {
		setSpOpen(true);
	setTempFoodQuantity(parseInt(value));
	
	if(value>0){
			setTempFoodQuantityDisabled(false);
		}else{
			setTempFoodQuantityDisabled(true);
		}
  };
  
  
  const handleSpClose = (e,reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSpOpen(false);
  };
  
    const action = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSpClose}
		>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );
  
  /*COMPLETE Client lOG*/
    const [completeLogQuestions, setCompleteLogQuestions] = useState(['Was the quantity of food and drink that the participant had yesterday about what they usually have, less than usual or more than usual:','If different than usual was this because:']);
    const [completeLogAnswers, setCompleteLogAnswers] = useState(['','']);
    const [completeLogModalStatus, setCompleteLogModalStatus] = useState(false);
	const handleCompleteLogModalOpen = () => {
		setCompleteLogModalStatus(true);
	};
	const handleCompleteLogModalClose = () => {
		setCompleteLogModalStatus(false);
	};
	
	const handleCompleteLogModalCloseAndOpenFood= () => {
		setCompleteLogModalStatus(false);
	};
  //handleCompleteClientLog
  	const handleCompleteClientLogModal = (event) => {
		console.log('complete log',clientLogData);
		setCompleteLogModalStatus(true);
	}
	
	const handleCompleteClientLog = (event) => {
		console.log('complete log',clientLogData);
		console.log('completeLogAnswers',completeLogAnswers);
		var finish_questions=[
		{'question':completeLogQuestions[0],'answere':completeLogAnswers[0]},
		{'question':completeLogQuestions[1],'answere':completeLogAnswers[1]},
		];
		clientLogData.finish_questions=finish_questions;
		clientLogData.completed=true;
		ClientLogService.update(clientLogData).then(function(res){
				console.log(res.data);
			setCompleteLogModalStatus(false);
				
			}).catch(function(error){
					console.log(error);
			});
	}
	
	//quantity
	const [quantity, setQuantity] = useState('');
	const handleQuantityChange = (event) => {
		setQuantity(event.target.value);
	};
	
	//quantification method
	const [quantificationMethod, setQuantificationMethod] = useState('');
	const handleQuantificationMethodChange = (event) => {
		setQuantificationMethod(event.target.value);
	};
	
	//cooking_methods
	const [cookingMethod, setCookingMethod] = useState('');
	const handleCookingMethodChange = (event) => {
		setCookingMethod(event.target.value);
	};
	
	//beverage_codes
	const [beverageCode, setBeverageCode] = useState('');
	const handleBeverageCodeChange = (event) => {
		setBeverageCode(event.target.value);
	};
	
	
	//packaging_types
	const [packagingType, setPackagingType] = useState('');
	const handlePackagingTypeChange = (event) => {
		setPackagingType(event.target.value);
	};
	
	
	//packaging_size
	const [packagingSize, setPackagingSize] = useState(0);
	const handlePackagingSizeChange = (event) => {
		setPackagingSize(event.target.value);
	};
	
	function resetClientFoodLogData(){
		setQuantificationMethod('');
		setCookingMethod('');
		setBeverageCode('');
		setPackagingType('');
		setPackagingSize(0);
	}
	
	//handleSwitchView
	const [tableView, setTableView] = useState(true);
	const handleSwitchView = (event) => {
		if(tableView){
			setTableView(false);
		}else{
			setTableView(true);
		}
		console.log('tableView',tableView);
	};
	
	
	/*update food quantity*/
	const [updateQuantityFoodModal,setUpdateQuantityFoodModal]=useState(false);
	const [tempFoodQuantityDisabled,setTempFoodQuantityDisabled]=useState(true);
	const [tempFoodQuantity, setTempFoodQuantity] = useState(0);
	const hangleTempFoodQuantity = (event) => {
		let _value=event.target.value;
		setTempFoodQuantity(event.target.value);
		if(_value>0){
			setTempFoodQuantityDisabled(false);
		}else{
			setTempFoodQuantityDisabled(true);
		}
	};
	
	
	const handleEditQuantityFoodModal= (event,food) => {
		setTempFood(food);
		console.log(food);
		loadSmartPortion(food.food);
		setTempFoodQuantity(food.quantity);
		setUpdateQuantityFoodModal(true);
	}
	//
	const handleUpdateFoodQuantityModalClose= (event) => {
		setUpdateQuantityFoodModal(false);
	}

	const handleUpdateFoodQuantity= (event) => {
		tempFood.quantity=tempFoodQuantity;
		ClientFoodLogService.update(tempFood).then(function(res){
			console.log(res.data);
			loadClientMealFoodLogById(client_log_id);
			setUpdateQuantityFoodModal(false);
		}).catch(function(error){
			console.log(error);
		});
		
	}
	/*delete food */
	const [deleteFoodModal,setDeleteFoodModal]=useState(false);

	const handleDeleteFoodModal= (event,food) => {
		console.log(food);
		setTempFood(food);
		setTempLogFood(food.food);
		setDeleteFoodModal(true);
	}
	
	const handleDeleteFoodYes= (event) => {
		console.log('tempFood',tempFood);
		ClientFoodLogService.deleteById(tempFood._id).then(function(res){
			console.log(res.data);
			loadClientMealFoodLogById(client_log_id);
			setDeleteFoodModal(false);
		}).catch(function(error){
			console.log(error);
		});
	
	};
	
	const handleDeleteFoodModalClose= (event) => {
		setDeleteFoodModal(false);

	};
	
	/*edit food quantity*/
/*	const [quantityEditMode,setQuantityEditMode]=useState(false);
	const [tempFoodQuantity,setTempFoodQuantity]=useState("");
	const handQuantityEditModeOn = (event) => {
		setQuantityEditMode(true);
	};
	
	const handQuantityEditModeOff = (event) => {
		setQuantityEditMode(false);
  };*/
	
  return(
  <>
  {globalSettingsLoaded ?
	<>
	<TopPrivateNavigation/>
	<AppLogout>
	
		{/* error no project found */}
	{(!projectFound) ?
		<>
		
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
		 <Typography color="text.primary">ClientLog</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		
		
		</>
	:<></>}
	{/* if project is found */}
	{(projectFound) ?
	<>
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>
		 <Link
          underline="hover"
          color="inherit"
          href={`/client/view/${clientData._id}`}
        >
          {clientData.code}
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/client/logs/${clientData._id}`}
        >
          Logs
        </Link>
		 <Typography color="text.primary">{clientLogData.name}</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		
	</>
	:<></>}
	 

	  
	  <table width="100%" style={{cellPadding:'3px'}}>
	  <tbody>
	 
	  <tr>
		<td><h5>Name</h5></td>
		<td>
			 <h3>
	  {nameEditMode ?
	  <>
	  <TextField
          label="Name"
          id="standard-size-small"
          //defaultValue="Small"
          size="small"
		  value={tempLogName}
          variant="standard"
		  onChange={(e) => {
			setTempLogName(e.target.value);
		}}
        />
	  <Button onClick={handNameEditModeOff}  variant="contained" size="small">
          Save
        </Button>
	  </>
	  :
	  <>
	  
	  {clientLogData.name} 
	  <IconButton onClick={handNameEditModeOn} color="primary" aria-label="">
        <EditIcon />
      </IconButton>
	  
	  </>}
	  
	  </h3>
		</td>
		<td><h5>Date</h5></td>
		<td>{formatDate(clientLogData.date)}</td>
		<td><h5>Day Of Week</h5></td>
		<td>{clientLogData.day_of_week}</td>
		<td><h5>Work/School day</h5></td>
		<td>
			{checkIfNull(clientLogData.work_school_day) ?
			<>
			
			</>:
			<>
			{(clientLogData.work_school_day) ?<>Yes</>:<>No</>}
			</>}
		</td>
	  </tr>
	  </tbody>
	</table>
	
	<h3>Meals</h3>
	
	<Button  variant="contained" endIcon={<AddIcon />}  onClick={handleNewMealModal}>
			Add new Meal  
	</Button>
	
	{/* add/edit meal dialog*/}
	 <Dialog  open={openNewEditMealLogModal}  >
  <Box component="form" onSubmit={handleSubmitNewMealLog} noValidate sx={{ mt: 1 }}>
			<DialogTitle>
			{mealEditMode ?
			<>
			Edit Meal Log
			</>:<>
			New Meal Log
			</>}
			</DialogTitle>
			<DialogContent>
          <DialogContentText>
		
          </DialogContentText>
			{ ShowErrorMessage &&
				<Alert severity="error">{ErrorText}</Alert>
			} 
			{ ShowSuccessMessage &&
				<Alert severity="success">{SuccessText}</Alert>
			}
			<br/>
			
			{/* Meal type and other*/}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Meal Type</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={mealType}
					label="Day Of Week"
					onChange={(e) => handleMealTypeChange(e)}
				  >
				  {meals.map((meal,index) => (
					  <MenuItem key={meal} value={meal}>{meal}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherMealType &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other meal type"
				  name="otherMealType"
				    value={mealTypeOther}
				onChange={(e) => handleMealTypeOtherChange(e)}
				/>
				
				}

				<br/>
				
				 <LocalizationProvider  dateAdapter={AdapterDayjs}>
				  <DemoContainer sx={{ m: 1, width: '500px'}} components={['TimePicker']}>
					<TimePicker
					  name="mealTime"
					  label="Time"
					  value={mealTime}
					  ampm={false}
					  onChange={(e) => handleMealTimeChange(e)}
					/>
				  </DemoContainer>
				</LocalizationProvider>
				
				
				
				{/* location_prepared */}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Location prepared</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={locationPrepared}
					label="Location prepared"
					onChange={(e) => handleLocationPreparedChange(e)}
				  >
				  {preparedLocations.map((loc,index) => (
					  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherLocationPrepared &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other location prepared"
				  name="otherLocationPrepared"
				  value={locationPreparedOther}
				onChange={(e) => handleLocationPreparedOtherChange(e)}
				/>
				
				}

				<br/>
				
				{/* location_eaten */}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Location eaten</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={locationEaten}
					label="Location eaten"
					onChange={(e) => handleLocationEatenChange(e)}
				  >
				  {eatenLocations.map((loc,index) => (
					  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherLocationEaten &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other location eaten"
				  name="otherLocationEaten"
				    value={locationEatenOther}
					onChange={(e) => handleLocationEatenOtherChange(e)}
				/>
				
				}
				<br/>
				{/* tv_and_screens_use */}
				 <FormControl sx={{ m: 1, width: '500px' }}>
				    <InputLabel id="demo-simple-select-label">TV/Screen use during meal</InputLabel>
					  <Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={tvAndScreenUse}
						label="Tv & Screen"
						name="tv_and_screen_use"
						onChange={handleTvAndScreenUseChange}
					  >
						<MenuItem value={true}>Yes</MenuItem>
						<MenuItem value={false}>No</MenuItem>
					  </Select>
				</FormControl>
				{/*
				<h3>Notes</h3>
				<Editor
				toolbar={NotesEditorToolbar}
				editorStyle={{ border: "1px solid grey" ,backgroundColor:"white",minHeight:"200px"}}
				editorState={editorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onEditorStateChange}
/>*/}

				<br/><br/>
				
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewEditMealLogModalClose}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
		</Box>
      </Dialog>
	
	
	 <Dialog  open={openNewMealLogModal}  >
		<Box component="form" onSubmit={handleSubmitNewMealLog} noValidate sx={{ mt: 1 }}>
			<DialogTitle>New Meal Log</DialogTitle>
			<DialogContent>
          <DialogContentText>
      
          </DialogContentText>
			{ ShowErrorMessage &&
				<Alert severity="error">{ErrorText}</Alert>
			} 
			{ ShowSuccessMessage &&
				<Alert severity="success">{SuccessText}</Alert>
			}
			<br/>
			
			{/* Meal type and other*/}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Meal Type</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={mealType}
					label="Day Of Week"
					onChange={(e) => handleMealTypeChange(e)}
				  >
				  {meals.map((meal,index) => (
					  <MenuItem key={meal} value={meal}>{meal}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherMealType &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other meal type"
				  name="otherMealType"
				  value={mealTypeOther}
				onChange={(e) => handleMealTypeOtherChange(e)}
				/>
				
				}

				<br/>
				
				 <LocalizationProvider  dateAdapter={AdapterDayjs}>
				  <DemoContainer sx={{ m: 1, width: '500px'}} components={['TimePicker']}>
					<TimePicker
					  name="mealTime"
					  label="Time"
					  value={mealTime}
					  ampm={false}
					  onChange={(e) => handleMealTimeChange(e)}
					/>
				  </DemoContainer>
				</LocalizationProvider>
				
				
				
				{/* location_prepared */}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Location prepared</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={locationPrepared}
					label="Location prepared"
					onChange={(e) => handleLocationPreparedChange(e)}
				  >
				  {preparedLocations.map((loc,index) => (
					  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherLocationPrepared &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other location prepared"
				  name="otherLocationPrepared"
				   value={locationPreparedOther}
				onChange={(e) => handleLocationPreparedOtherChange(e)}
				/>
				
				}

				<br/>
				
				{/* location_eaten */}
				<FormControl sx={{ m: 1, width: '500px'}}>
				  <InputLabel id="demo-select-large-label">Location eaten</InputLabel>
				  <Select
					labelId="demo-select-small-label"
					id="demo-select-small"
					value={locationEaten}
					label="Location eaten"
					onChange={(e) => handleLocationEatenChange(e)}
				  >
				  {eatenLocations.map((loc,index) => (
					  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
				  ))}
				  </Select>
				</FormControl>
				{ showOtherLocationEaten &&
				<TextField
				sx={{ m: 1, width: '500px' }}
				  margin="normal"
				  required
				  fullWidth
				  id="name"
				  label="Other location eaten"
				  name="otherLocationEaten"
				  value={locationEatenOther}
				onChange={(e) => handleLocationEatenOtherChange(e)}
				/>
				
				}
				<br/>
				{/* tv_and_screens_use */}
				 <FormControl sx={{ m: 1, width: '500px' }}>
				    <InputLabel id="demo-simple-select-label">TV/Screen use during meal</InputLabel>
					  <Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={tvAndScreenUse}
						label="Tv & Screen"
						name="tv_and_screen_use"
						onChange={handleTvAndScreenUseChange}
					  >
						<MenuItem value={true}>Yes</MenuItem>
						<MenuItem value={false}>No</MenuItem>
					  </Select>
				</FormControl>
				{/*
				<h3>Notes</h3>
				<Editor
				toolbar={NotesEditorToolbar}
				editorStyle={{ border: "1px solid grey" ,backgroundColor:"white",minHeight:"200px"}}
				editorState={editorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onEditorStateChange}
/>*/}

				<br/><br/>
				
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewMealLogModalClose}>Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogActions>
		</Box>
      </Dialog>
	  
	  	
	{/* remove Meal dialog */}
	<Dialog
        open={deleteMealModal}
        onClose={handleDeleteMealModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
	<DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete this meal?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
		  {tempMeal.type}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleDeleteMealYes(e)}> Yes</Button>
          <Button onClick={(e) => handleDeleteMealModalClose(e)}> No</Button>
        </DialogActions>
      </Dialog>
	{/* end remove Meal dialog */}


	{/* remove Food dialog */}
	<Dialog
        open={deleteFoodModal}
        onClose={handleDeleteFoodModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
	<DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete this food?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
		  {tempLogFood.name}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleDeleteFoodYes(e)}> Yes</Button>
          <Button onClick={(e) => handleDeleteFoodModalClose(e)}> No</Button>
        </DialogActions>
      </Dialog>
	{/* end remove food dialog */}

	
	
	{/* edit Food quantity dialog */}
		<Dialog
        open={updateQuantityFoodModal}
        onClose={handleUpdateFoodQuantityModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
	<DialogTitle id="alert-dialog-title">
          {"Update food quantity"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
		  <br/>
		  
		  
				<TextField
					type="number" 
					label="Quantity(g)"
					id="outlined-end-adornment"
					sx={{  width: '500px' }}
					value={tempFoodQuantity}
					onChange={hangleTempFoodQuantity}
					InputProps={{
						endAdornment: <InputAdornment position="end">grams</InputAdornment>,
					}}
				/>
				
							{modulesEnabled['smart_portions'] &&
								<>
									{smartPortionLoaded && 
									<>
									{/*{smartPortion.sp.exists &&
										<>*/}
									
									<br/><br/><b>Smart Portions</b><br/>
									<SmartPortionComponent smartPortionLoaded={smartPortionLoaded} smartPortion={smartPortion} onClick={handleUpdateFoodQuantityClick}  />
										{/*</>}*/}
								
									</>}		
								</>}
				
          </DialogContentText>
        </DialogContent>
        <DialogActions>
		 <Button  onClick={(e) => handleUpdateFoodQuantityModalClose(e)}> Cancel</Button>
          <Button disabled={tempFoodQuantityDisabled} onClick={(e) => handleUpdateFoodQuantity(e)}>Save</Button>
        </DialogActions>
  </Dialog>
	{/* end edit food quantity dialog */}
	
	
	{(clientMealLogData.length==0) ?
	<>
		<br/><br/>None Found
	</>
	:<>
	
	<div style={{ width: '100%' }}>
		<Box
			sx={{
			display: 'flex',
			flexDirection: 'row-reverse',
			p: 0,
			m: 0,
		//   bgcolor: 'background.paper',
			borderRadius: 1,
		}}
      >
	<Button onClick={(e) => handleSwitchView(e)} endIcon={<ImportExportIcon/>}  size="small" color="primary">
		Switch View 
	</Button>
	  </Box>
	</div>
	
	{/* switch views */}
	{(tableView)?
	<>
		<div>
	    <TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell></TableCell>
						{clientMealLogData.map((meal,index) => (
							<TableCell key={index} align="right">{meal.type}  {formatTime(meal.time)}
							<Grid container justifyContent="flex-end">
							
							<IconButton onClick={(e) => handleEditMealModal(e,meal)} edge="end" aria-label="edit"> <EditIcon /> </IconButton>
		  <IconButton onClick={(e) => handleDeleteMealModal(e,meal)} edge="end" aria-label="edit"> <DeleteIcon /> </IconButton>
			  {/*<Button onClick={(e) => handleEditMealModal(e,meal)}> <EditIcon /></Button>
		  <Button onClick={(e) => handleDeleteMealModal(e,meal)}> <DeleteIcon /></Button>*/}
							</Grid>
						</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{clientFoodLogData.map((food) => (
					<TableRow key={food._id}  sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
					  <TableCell component="th" scope="row">
					  {/*food or recipe */}
						  {/*{food.food_or_recipe=='food'?(
					  <>
						{food.food.name}
					  </>):(<>
						{food.recipe.name}
					</>)}*/}
					  
					  {food.food_or_recipe=='food'?(
						<><FastfoodIcon /> {food.food.name}</>
						): food.food_or_recipe=='recipe'?(
						<><MenuBookIcon /> {food.recipe.name}</>
						):(
							<QuestionMarkIcon />
						)}
					  
					  </TableCell>
					  {clientMealLogData.map((meal,index) => (
					  <TableCell key={index} align="right">
						{(meal.id==food.client_meal_log_id)?
						<>
						{food.quantity}g
						
						{/*
						{quantityEditMode ?
						  <>
						  <TextField
							  label="Name"
							  id="standard-size-small"
							  //defaultValue="Small"
							  size="small"
							  value={tempFoodQuantity}
							  variant="standard"
							  onChange={(e) => {
								setTempFoodQuantity(e.target.value);
							}}
							/>
						  <Button onClick={handQuantityEditModeOff}  variant="contained" size="small">
							  Save
							</Button>
						  </>
						  :
						  <>
						  <IconButton onClick={handQuantityEditModeOn} color="primary" aria-label="">
							<EditIcon />
						  </IconButton>
						  
						</>}
						*/}
						<IconButton onClick={(e) => handleEditQuantityFoodModal(e,food)} edge="end" aria-label="edit"> <EditIcon /> </IconButton>
						<IconButton onClick={(e) => handleDeleteFoodModal(e,food)} edge="end" aria-label="delete"><DeleteIcon /></IconButton>
						</>
					  :<></>}
					  </TableCell>
					  ))}
					</TableRow>
					))}
					<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
						<TableCell component="th" scope="row">
						</TableCell>
						  {clientMealLogData.map((meal,index) => (
						  <TableCell key={index} align="right">
						  <Button  variant="contained" endIcon={<AddIcon />} onClick={(e) => handleOpenFoodModal(e,meal)} >
								Add Food  
							</Button>
							
						  </TableCell>
						  ))}
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	</div>
	</>
	:<>
	<div>
	{clientMealLogData.map((meal,index) => (
      <Accordion key={meal._id}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {meal.type} {formatTime(meal.time)}
		 
        
		</AccordionSummary>
        <AccordionDetails>
		<Grid container justifyContent="flex-end">
		  <IconButton onClick={(e) => handleEditMealModal(e,meal)} edge="end" aria-label="edit"> <EditIcon /> </IconButton>
		  <IconButton onClick={(e) => handleDeleteMealModal(e,meal)} edge="end" aria-label="edit"> <DeleteIcon /> </IconButton>
			  {/*  <Button onClick={(e) => handleEditMealModal(e,meal)}> <EditIcon /></Button>
		  <Button onClick={(e) => handleDeleteMealModal(e,meal)}> <DeleteIcon /></Button>*/}
		</Grid>
		 
          <Button  variant="contained" endIcon={<AddIcon />} onClick={(e) => handleOpenFoodModal(e,meal)} >
					Add Food  
			</Button>
			
			
			<br/>
			
	<List sx={{ width: '100%', bgcolor: 'background.paper' }}>
	
	{clientMealFoodLogData[meal._id].map((food) => (
	<>
      <ListItem key={food._id} alignItems="flex-start"
		  secondaryAction={
			  <>
			  <IconButton onClick={(e) => handleEditQuantityFoodModal(e,food)} edge="end" aria-label="edit"> <EditIcon /> </IconButton>
				<IconButton onClick={(e) => handleDeleteFoodModal(e,food)} edge="end" aria-label="delete"> <DeleteIcon /> </IconButton>
				</>
		  } >
        <ListItemAvatar>
		
		{food.food_or_recipe=='food'?(
		<Avatar>
            <FastfoodIcon />
          </Avatar>
			): food.food_or_recipe=='recipe'?(
			<Avatar>
            <MenuBookIcon />
          </Avatar>
		):(
		<Avatar>
            <QuestionMarkIcon />
          </Avatar>
		)}
          
        </ListItemAvatar>
        <ListItemText
         primary={food.food_or_recipe=='food'?
					(
					<>{food.food.name}</>
					): food.food_or_recipe=='recipe'?
					(
					<>{food.recipe.name}</>
					):(
					<></>
					)}
          secondary={
            <Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
			  {food.quantity}g
              </Typography>
            </Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" /></>
		))}
    </List>
        </AccordionDetails>
      </Accordion>
		))}
    
</div>
	
	
	
	</>}
	
		</>}{/* end check for meals length*/}
	

<div>

<Snackbar
								open={spOpen}
								open={spOpen}
								autoHideDuration={6000}
								onClose={handleSpClose}
								message="Quantity updated"
								action={action}
							  />
							  
							  
    <Modal
		open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
    >
    <Box sx={{ ...style_parent, width: 800 }}>
          <h2 id="parent-modal-title">Add food to {tempMeal.type}</h2>
			 <Box sx={{ width: '100%' }}>
				  <Stepper activeStep={activeStep}>
					{steps.map((label, index) => {
					  const stepProps = {};
					  const labelProps = {};
					  if (isStepOptional(index)) {
						labelProps.optional = (
						  <Typography variant="caption">Optional</Typography>
						);
					  }
					  if (isStepSkipped(index)) {
						stepProps.completed = false;
					  }
					  return (
						<Step key={label} {...stepProps}>
						  <StepLabel {...labelProps}>{label}</StepLabel>
						</Step>
					  );
					})}
				  </Stepper>
				  {activeStep === steps.length ? (
					<Fragment>
					  <Typography sx={{ mt: 2, mb: 1 }}>
						All steps completed - you&apos;re finished
					  </Typography>
					  <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
						<Box sx={{ flex: '1 1 auto' }} />
						<Button onClick={handleReset}>Reset</Button>
					  </Box>
					</Fragment>
				  ) : (
					<Fragment>
					  <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>
					   {(activeStep==0) ?
						<>
						
					{/*food search bar */}
					<TextField fullWidth onChange={(e) => {handleFoodSearchChange(e)}} id="outlined-basic" label="food search" variant="outlined" />
						<br/><br/>
						{FilteredFoodData.length>0 ?
						<>
							{foodListPageSize<=FilteredFoodData.length ?
							<>
								showing {foodListPageSize} of {FilteredFoodData.length} found
							</>:<>
								showing all of {FilteredFoodData.length} found
							</>}
						</>:<>
						
						</>}

						<br/>
						
						<List sx={{ width: '100%', bgcolor: 'background.paper' }}>
						 {selectPage(FilteredFoodData,foodListPageSize).map((food) => (
						 <>
						  <Divider variant="" component="li" />
						 <ListItem alignItems="flex-start" key={food._id}>
							<ListItemAvatar style={{paddingRight:'15px'}}>
								{food.type=='food'?(
									<FastfoodIcon sx={{ fontSize: 50 }} />
								):(
									<MenuBookIcon sx={{ fontSize: 50 }} />
								)}
							  
							  
							</ListItemAvatar>
							<IconButton onClick={(e) => {handleFoodInfoOpen(e,food)}} aria-label="delete">
								<InfoOutlinedIcon />
							  </IconButton>
							
							<ListItemText
							  primary={food.code} 
								secondary={food.name}
							/> 
							<Button onClick={(e) => {handleAddToLog(e,food)}}>Add {food.type} to log</Button>
						  </ListItem>
						  
						 
						  <br/>
						 <Divider variant="" component="li" />
						
						 </>
							))}
						 
					   </List>
					   {foodListPageSize<=FilteredFoodData.length ? <>
						   <Button onClick={(e) => {handleShowMore(e,FilteredFoodData.length)}}>Show more</Button>
					   </>:<></>}
					 
						<br/>
						</>
						:<></>}
						
						{(activeStep==1) ?
						<>
							<br/>Select Quantity <br/><br/>
							
							
							
							
							<TextField
								 type="number" 
								  label="Quantity(g)"
								  id="outlined-end-adornment"
								  sx={{  width: '500px' }}
								  value={quantity}
								  onChange={handleQuantityChange}
								  InputProps={{
									endAdornment: <InputAdornment position="end">grams</InputAdornment>,
								  }}
								/>
								<br/><br/>
								
								{modulesEnabled['smart_portions'] &&
								<>
									{smartPortionLoaded && 
									<>
									{/*{smartPortion.sp.exists &&
										<>*/}
									<br/><b>Smart Portions</b><br/>
									<SmartPortionComponent smartPortionLoaded={smartPortionLoaded} smartPortion={smartPortion} onClick={handleClick}  />
										{/*</>}*/}
								
									</>}		
								</>}
								
							
						</>
						:<></>}
						
						{(activeStep==2) ?
						<>
							

	{/*//quantification method
	const [quantificationMethod, setQuantificationMethod] = useState('');
	const handleQuantificationMethodChange = (event) => {
		setQuantificationMethod(event.target.value);
							};*/}
		<FormControl  sx={{ m: 1, width: 500 }}>
			<InputLabel id="demo-select-large-label">Quantification Method</InputLabel>
			<Select
				labelId="demo-select-small-label"
				id="demo-select-small"
				value={quantificationMethod}
				label="Quantification Method"
				onChange={(e) => handleQuantificationMethodChange(e)}
				>
				{quantification_methods.map((opt,index) => (
					<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				))}
			</Select>
		</FormControl>
		  
		  <br/>
		  
		  						{/*}
	//cooking_methods
	const [cookingMethod, setCookingMethod] = useState('');
	const handleCookingMethodChange = (event) => {
		setCookingMethod(event.target.value);
						};*/}
		  
		 <FormControl  sx={{ m: 1, width: 500 }}>
			<InputLabel id="demo-select-large-label">Cooking Method</InputLabel>
			<Select
				labelId="demo-select-small-label"
				id="demo-select-small"
				value={cookingMethod}
				label="Cooking Method"
				onChange={(e) => handleCookingMethodChange(e)}
				>
				{cooking_methods.map((opt,index) => (
					<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				))}
			</Select>
		</FormControl>
		  
		  <br/>
		  
		  
	{/*//beverage_codes
	const [beverageCode, setBeverageCode] = useState('');
	const handleBeverageCodeChange = (event) => {
		setBeverageCode(event.target.value);
	};
	*/}
			<FormControl  sx={{ m: 1, width: 500 }}>
			<InputLabel id="demo-select-large-label">Beverage Code</InputLabel>
			<Select
				labelId="demo-select-small-label"
				id="demo-select-small"
				value={beverageCode}
				label="Beverage Code"
				onChange={(e) => handleBeverageCodeChange(e)}
				>
				{beverage_codes.map((opt,index) => (
					<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				))}
			</Select>
		</FormControl>
		  
		  <br/>
		  
		  {/*
	//packaging_types
	const [packagingType, setPackagingType] = useState('');
	const handlePackagingTypeChange = (event) => {
		setPackagingType(event.target.value);
	};*/}

		<FormControl  sx={{ m: 1, width: 500 }}>
			<InputLabel id="demo-select-large-label">Packaging Type</InputLabel>
			<Select
				labelId="demo-select-small-label"
				id="demo-select-small"
				value={packagingType}
				label="Packaging Type"
				onChange={(e) => handlePackagingTypeChange(e)}
				>
				{packaging_types.map((opt,index) => (
					<MenuItem key={opt} value={opt}>{opt}</MenuItem>
				))}
			</Select>
		</FormControl>
		  
		  <br/>  <br/>
							<TextField
								 type="number" 
								  label="Packaging Size(g)"
								  id="outlined-end-adornment"
								  sx={{  width: '500px' }}
								  value={packagingSize}
								  onChange={(e) => handlePackagingSizeChange(e)}
								  InputProps={{
									endAdornment: <InputAdornment position="end">grams</InputAdornment>,
								  }}
								/>
							<br/><br/>


		  
							
							
							
							
						</>
						:<></>}
					 
					  
					  
					  <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
			
						<Button
						  color="inherit"
						  disabled={activeStep === 0}
						  onClick={handleBack}
						  sx={{ mr: 1 }}
						>
						  Back
						</Button>
						<Box sx={{ flex: '1 1 auto' }} />
						{isStepOptional(activeStep) && (
						  <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
							Skip
						  </Button>
						)}
						{activeStep!==0?
						<>
						
							
								{quantity>0?
								<>
								
									
								<Button onClick={handleNext}>
								  {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
								</Button>
								</>:
								<>
						
						
								</>}
						</>:
						<>
						
						
						</>
						}
						
						
					  </Box>
					</Fragment>
				  )}
				</Box>



	{/* More Info Modal*/}
	<Fragment>
      <Modal
        open={openFoodInfo}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: '80%' ,height:'80%'}}>
          <h2 id="child-modal-title">{tempFood.code} - {tempFood.name}</h2>
		  {foodTranslationsLoaded ? <>
			<TableContainer sx={{ maxHeight:'80%' }} component={Paper}>
			 <Table sx={{ Width: '100%'}} aria-label="simple table">
				<TableHead>
				  <TableRow>
					<TableCell>Typical Values</TableCell>
					<TableCell align="left">Per 100g</TableCell>
				  </TableRow>
				</TableHead>
				<TableBody>
				  {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
					<TableRow key={key}>
					  <TableCell component="th" scope="row">{foodTranslations[key]}</TableCell>
						  <TableCell component="td" scope="row">{tempFood[key]}</TableCell>
					</TableRow>
				  ))}
				</TableBody>
			  </Table>
		  </TableContainer>
			</>:<></>}
		  <Button onClick={handleFoodInfoClose}>Close</Button>
        </Box>
      </Modal>
    </Fragment>
	{/* End More Info Modal*/}
        </Box>
      </Modal>
    </div>
	{/*more info modal*/}
	
		<h3>Notes <Chip label="Autosave" size="small" /></h3>
		<Editor
		toolbar={NotesEditorToolbar}
				editorStyle={{ border: "1px solid grey" ,backgroundColor:"white",minHeight:"200px"}}
				editorState={logNotesEditorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onLogNotesEditorStateChange}
				/>

				<br/><br/>
	<br/>
	
	
	<div style={{ width: '100%' }}>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
       //   bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  {!clientLogData.completed && <>
			<Button onClick={(e) => handleCompleteClientLogModal(e)} variant="contained" color="primary">
				Complete
			</Button>
	  </>}

	
	<Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={completeLogModalStatus}
        onClose={handleCompleteLogModalClose}
      >
        <DialogTitle>Complete 24hr recall</DialogTitle>
        <DialogContent>
		  <h3>Did you forget to add some Food? If so go back and add them</h3>
		     <ul>
			{forgottenFoods.map((food,index) => (
				<li key={food} >{food}</li>
			))}
			</ul>
			<Button onClick={handleCompleteLogModalCloseAndOpenFood}>Opps! yes I did</Button>
		    <h3>End of recall questions</h3>
			
			<h4>Question 1</h4>
			<h5>{completeLogQuestions[0]}</h5>
			
			<FormControl>
			  <RadioGroup
				aria-labelledby="demo-radio-buttons-group-label"
				//defaultValue="female"
				name="radio-buttons-group"
				value={completeLogAnswers[0]}
				onChange={(e) => {
							console.log(e.target.value);
							let newArr = [...completeLogAnswers];
							newArr[0]=e.target.value;
							setCompleteLogAnswers(newArr);
					  }}
			  >
				<FormControlLabel value="Less than usual" control={<Radio />} label="Less than usual" />
				<FormControlLabel value="About the same as usual" control={<Radio />} label="About the same as usual" />
				<FormControlLabel value="More than usual" control={<Radio />} label="More than usual" />
			  </RadioGroup>
			</FormControl>
			
			<h4>Question 2</h4>
			<h5>{completeLogQuestions[1]}</h5>
			<FormControl>
			  <RadioGroup
				aria-labelledby="demo-radio-buttons-group-label"
				//defaultValue="female"
				name="radio-buttons-group"
				value={completeLogAnswers[1]}
				onChange={(e) => {
							console.log(e.target.value);
							let newArr = [...completeLogAnswers];
							newArr[1]=e.target.value;
							setCompleteLogAnswers(newArr);
					  }}
			  >
				<FormControlLabel value="They were feeling unwell" control={<Radio />} label="They were feeling unwell" />
				<FormControlLabel value="It was not a typical week" control={<Radio />} label="It was not a typical week" />
				<FormControlLabel value="Other" control={<Radio />} label="Other" />
			  </RadioGroup>
			</FormControl>
			
        </DialogContent>
        <DialogActions>
		<Button onClick={handleCompleteLogModalClose}>Cancel</Button>
          <Button onClick={handleCompleteClientLog}>Complete</Button>
        </DialogActions>
      </Dialog>
	  </Box></div>
	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	</>
	:<></>}
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
	</>
	:<></>}

	</AppLogout>
	</>:<>
 <CircularProgress />
  </>}
	</>
  ) 
  ;
};

export default ClientLog;